import React from 'react';
import { InputLabel, Spacer } from 'src/common';

// One labelled field laid out the app-standard way: a 20px spacer above, then an
// uppercase InputLabel (with the standard ` *` when required) directly over the
// control — same as AddUserModal et al.
export const FormField: React.FC<{ label: string; required?: boolean; children: React.ReactNode }> = ({
  label,
  required,
  children,
}) => (
  <>
    <Spacer $px={20} />
    <InputLabel>{`${label.toUpperCase()}${required ? ' *' : ''}`}</InputLabel>
    {children}
  </>
);
